import { render } from "./FilterSegmentModal.vue?vue&type=template&id=4c22647c"
import script from "./FilterSegmentModal.vue?vue&type=script&lang=js"
export * from "./FilterSegmentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__